import Request from './request'

const Airalo = {
  getAiraloSimcards(params, callback) {
    Request.get('airalo/simcards', params).then(callback).catch(this.bad_answer)
  },
  getAiraloOrders(params, callback) {
    Request.get('airalo/orders', params).then(callback).catch(this.bad_answer)
  },
  getAiraloSimcard(id, callback) {
    Request.get('airalo/simcard/' + id).then(callback).catch(this.bad_answer)
  },
  updateAiraloSimcard(id, params, callback) {
    Request.put('airalo/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateStatusAiraloSimcard(iccid, params, callback) {
    Request.put('airalo/' + iccid, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Airalo
